import conf from "conf";

export default function Footer() {
  return (
    <footer className="w-full py-8 bg-newPrim">
      <div className="container flex flex-row justify-around items-center mx-auto text-sm text-white">
        <div className="text-center sm:text-left">
          © 2023 {conf.get("PROJECT_NAME")} Inc.
        </div>
        <div className="flex flex-row justify-center">
          <div>
            <a href="https://www.diceddigital.io/terms">Terms</a> |{" "}
            <a href="https://www.diceddigital.io/privacy">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
